import { array } from 'prop-types';
import React, { Component } from 'react';

import * as func from "../../../../../../utils/functions";
import RankingItem from './rankingItem';
import {EDIT_MODE} from "../../../../../../wpconfig"

class PopupScopus extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isEdit: EDIT_MODE.SHOW,
          field: "ranking",
          record : {
            "impact": null,
            "indicator_id": null,
            "indicator_type": "scopus",
            "indicator_year": null,
            "quartile": null,
            "ranking": null,
            "total_cites": null,
            "total_items": null,
            "sjr": null,
            "snip": null
          },
          pkKey: "ranking_id"
        };
      }
    
      componentDidMount() {
        this.props.indicator_id ?
        func.getData("admin/journal/" + func.getParams("record_id") + "/indicator/" + this.props.indicator_id, {}).then((response) => {
          this.setState({
            record: response.record
          })
        }) : (
          console.log("새로등록")
        )
      }
  
      onEditSave = (e) => {
  
        const { record } = this.state

        if (this.indicator_year.value === '') {
          this.indicator_year.focus();
        } else {
    
          if (record.indicator_id) {
            func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/" + record.indicator_id + "/update", record).then((response) => {
              if (response.code === 'ok') {
                this.props.togglePopup()
              } else {
              }
            })
          } else {
            func.updateData("admin/journal/" + func.getParams("record_id") + "/indicator/insert", record).then((response) => {
              if (response.code === 'ok') {
                this.props.togglePopup()
              } else {
              }
            })
          }
        }
      };
  
      onUpdate = () => {
        // console.log("저장")
        this.onEditSave()
      }
  
      onChange = (e) => {
        const { record } = this.state
  
        record[e.target.name] = e.target.value
  
        this.setState({
          record : record
        })
    };

    onRankingUpdate = (index, item, render) => {
      const { record } = this.state
      record.ranking[index] = item
      console.log(record)
      this.setState({ record : record })
    }
  
    onRankingRemove = (index, render) => {
      const { record } = this.state
      record.ranking.splice(index, 1);
      this.setState({ record : record })
    }
  
    onRankingInsert = () => {
      const { record } = this.state
      if (record[this.state.field].length > 0 && record[this.state.field][0][this.state.pkKey] === '') {
        this.showMessage('추가해주세요.')
      } else {
        const insertRecord = {
          "category_code": null,
          "category_count": null,
          "category_name": null,
          "indicator_type": "scopus",
          "percent": null,
          "quartile": null,
          "ranking": null,
          "ranking_id": null,
          "is_edit" : EDIT_MODE.SHOW_EDIT,
        }
        this.onEditIndex(0);
        // 데이터 변환 체크하기
        record[this.state.field].unshift(insertRecord)
        this.setState({ record : record })
      }
    }
  
    onEditIndex(id) {
      if(this.state.editIndex)
        this.refs["ref" + this.state.editIndex].onClose();
      else if(this.refs.ref)
        this.refs.ref.onClose();
      else if(this.refs["ref" + this.state.editIndex])
        this.refs["ref" + this.state.editIndex].onClose();
  
      this.setState({
        'editIndex' : id
      })
    }

    render() {
      const { record } = this.state;

        return (
          <>
            <div className="modal d-block pieces_modal PopupScopus" tabIndex="1"> 
              <div className="modal-dialog">
                <div className="modal-content rm">
                  <div className="modal-header">
                    <h5 className="modal-title">Scopus Indicator</h5>
                    <button type="button" className="btn-close" onClick={() => this.props.togglePopup()}></button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="container-fluid pl-0 pr-0 m-0 detail-wrap">
                        <div className="row mb-2">
                          <div className="col-md-2 form-group field-danger">
                            <label htmlFor="indicator_type"><strong>Indicator Type</strong></label>
                            <input type="text" id="indicator_type" name="indicator_type" className="form-control" readOnly="readOnly"  value={ record.indicator_type || 'scopus' } onChange={this.onChange} />
                          </div>
                          <div className="col-md-1 form-group">
                            <label htmlFor="indicator_year"><strong>Year</strong></label>
                            <input type="text" id="indicator_year" name="indicator_year" ref={(ref)=>this.indicator_year=ref} className="form-control" value={ record.indicator_year || '' } placeholder="2021" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="impact"><strong>CiteScore(IF)</strong></label>
                            <input type="text" id="impact" name="impact" className="form-control" value={ record.impact || '' } placeholder="1.0" onChange={this.onChange} />
                          </div>
                          <div className="col-md-1 form-group">
                            <label htmlFor="total_items"><small><strong>Total Items</strong></small></label>
                            <input type="text" id="total_items" name="total_items" className="form-control" value={ record.total_items || '' } placeholder="0" onChange={this.onChange} />
                          </div>
                          <div className="col-md-1 form-group">
                            <label htmlFor="total_cites"><small><strong>Total Cites</strong></small></label>
                            <input type="text" id="total_cites" name="total_cites" className="form-control" value={ record.total_cites || '' } placeholder="0" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="sjr"><strong>SJR(Eigenfactor)</strong></label>
                            <input type="text" id="sjr" name="sjr" className="form-control" value={ record.sjr || '' } placeholder="1.00" onChange={this.onChange} />
                          </div>
                          <div className="col-md-2 form-group">
                            <label htmlFor="snip"><strong>SNIP(Article Influence)</strong></label>
                            <input type="text" id="snip" name="snip" className="form-control" value={ record.snip || '' } placeholder="1.000" onChange={this.onChange} />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col d-flex justify-content-end">
                            <button type="button" className="btn btn-sm btn-primary mr-1" onClick={this.onUpdate}>저장</button>
                            <button type="button" className="btn btn-sm btn-secondary" onClick={() => this.props.togglePopup()}>닫기</button>
                          </div>
                        </div>
                      </div>
                    </form>
								{
									record[this.state.field] && 
									(
										<>
                    <div className="d-flex mt-4 mb-1">
                      <div className="flex-grow-1">
                        <h5 className="">카테고리 랭킹 정보</h5>
                      </div>
                      <div className="btn-group" role="group">
                        <button type="button" className="btn btn-sm btn-primary mr-1" onClick={this.onRankingInsert}>신규</button>
                      </div>
                    </div>
                    <div style={{maxHeight: "300px", overflowY: "auto"}}>
                      <table className="table table-striped table-thin mb-1 border-bottom">
                        <colgroup>
                          <col width="90px"></col>
                          <col width=""></col>
                          <col width="70px"></col>
                          <col width="70px"></col>
                          <col width="80px"></col>
                          <col width="60px"></col>
                          <col width="80px"></col>
                          <col width="80px"></col>
                          <col width="80px"></col>
                          <col width="90px"></col>
                        </colgroup>
                        <thead>
                        <tr>
                          <th className="pt-2 pb-2">코드</th>
                          <th>카테고리</th>
                          <th>Edition</th>
                          <th>랭킹유형</th>
                          <th>총 저널 수</th>
                          <th>랭킹</th>
                          <th>Percent</th>
                          <th>Percentile</th>
                          <th>Quartile</th>
                          <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                          record.ranking &&
                          record.ranking.map((rData, index) => {
                            return (
                              <RankingItem 
                                key={rData[this.state.pkKey]}
                                index={rData[this.state.pkKey]}
                                ref={"ref" + rData[this.state.pkKey]}
                                indicator_id={record.indicator_id}
                                arrIndex={index}
                                pkKey={this.state.pkKey}
                                record={rData}
                                onUpdate={this.onRankingUpdate}
                                onRemove={this.onRankingRemove}
                                // onReload={this.onReload}
                                onEditIndex={this.onEditIndex}
                                // showMessage={this.showMessage}
                              />
                            )
                          })
                        }
                        </tbody>
                      </table>
                    </div>
										</>
									)
								}
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-sm btn-secondary" onClick={() => this.props.togglePopup()}>닫기</button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
    }
}

export default PopupScopus;
